module.exports = __webpack_public_path__ + "img/logo.f97bf35f.svg";